import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './styles'

const propTypes = {
  customer: PropTypes.shape({
    name: PropTypes.string.isRequired,
    logo: PropTypes.string,
    industry: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    quote: PropTypes.string.isRequired,
    quotedBy: PropTypes.string.isRequired,
    quotedByTitle: PropTypes.string.isRequired,
    metrics: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      highlight: PropTypes.bool,
    })).isRequired,
    achievements: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
}

const CustomerSuccessCard = ({ customer }) => {
  return (
    <styles.Container>
      <styles.Header>
        <styles.CustomerInfo>
          {customer.logo && (
            <styles.Logo>
              <img src={customer.logo} alt={`${customer.name} logo`} />
            </styles.Logo>
          )}
          <styles.CustomerDetails>
            <styles.CustomerName>{customer.name}</styles.CustomerName>
            <styles.Industry>{customer.industry}</styles.Industry>
          </styles.CustomerDetails>
        </styles.CustomerInfo>
      </styles.Header>

      <styles.Content>
        <styles.Description>{customer.description}</styles.Description>

        <styles.MetricsGrid>
          {customer.metrics.map((metric, index) => (
            <styles.MetricCard key={index} highlight={metric.highlight}>
              <styles.MetricValue highlight={metric.highlight}>
                {metric.value}
              </styles.MetricValue>
              <styles.MetricLabel highlight={metric.highlight}>{metric.label}</styles.MetricLabel>
            </styles.MetricCard>
          ))}
        </styles.MetricsGrid>

        <styles.AchievementsList>
          <styles.AchievementsTitle>Key Achievements:</styles.AchievementsTitle>
          {customer.achievements.map((achievement, index) => (
            <styles.AchievementItem key={index}>
              <styles.CheckIcon>✓</styles.CheckIcon>
              {achievement}
            </styles.AchievementItem>
          ))}
        </styles.AchievementsList>

        <styles.QuoteSection>
          <styles.Quote>"{customer.quote}"</styles.Quote>
          <styles.QuoteAttribution>
            <styles.QuotedBy>{customer.quotedBy}</styles.QuotedBy>
            <styles.QuotedByTitle>{customer.quotedByTitle}</styles.QuotedByTitle>
          </styles.QuoteAttribution>
        </styles.QuoteSection>
      </styles.Content>
    </styles.Container>
  )
}

CustomerSuccessCard.propTypes = propTypes

export default CustomerSuccessCard